import * as React from "react"
// import PropTypes from "prop-types"
// import { Link } from "gatsby"
// import "./craft-image.scss"
import useSiteMetadata from "../../hooks/use-site-metadata"

// http://psunewstest.s3-website-us-east-1.amazonaws.com/storybook/?path=/story/paragraphs-hero-feature--sticky-image

const CraftImage = function ({
  srcset,
  alt = "",
  url,
  sizes = "100vw",
  className = "w-100",
  loading = "lazy", // lazy or eager
  focalPoint = [0.5, 0.5],
  hasFocalPoint = false,
}) {
  // const { siteUrl } = useSiteMetadata()
  const siteUrl = "https://cms.virtualfarm.psu.edu"

  // transform focal point data into percentages
  if (hasFocalPoint) {
    focalPoint[0] = `${focalPoint[0] * 100}%`
    focalPoint[1] = `${focalPoint[1] * 100}%`
  }

  // make sure we have data before trying to render an image with it
  if (typeof srcset !== "undefined") {
    return (
      <img
        className={className}
        loading={loading}
        // src={`https:${url}`}
        // src={`${siteUrl}${url}`}
        src={`${url}`}
        // srcSet={srcset.replace(/\/\//g, 'https://')}
        srcSet={srcset.replace(/.*\/uploads/g, `${siteUrl}/uploads`)}
        // srcSet={srcset}
        sizes={sizes}
        alt={alt}
        data-testid="image"
        data-hasfocalpoint={hasFocalPoint}
        data-focalpoint={focalPoint}
        style={{
          objectPosition: `${focalPoint[0]} ${focalPoint[1]}`,
        }}
      />
    )
  } else {
    return null
  }
}

// CraftImage.propTypes = {
//   srcset: PropTypes.string,
// }

// CraftImage.defaultProps = {
//   srcset: ``,
// }

export default CraftImage
